import {
  ActionButtonProps,
  Box,
  BoxProps,
  ColorOptions,
  Form,
  required,
  SpacerNew,
  Text,
  TextProps,
} from '@jfs/ui-new'
import { GradientButton } from '../../components/GradientButton'
import React, { useCallback, useEffect } from 'react'
import { Container } from '../../../../pg/src/screens/JioPayFinanceHub/comps/Container'
import { DropdownOptimised } from '../../components/DropdownNew'
import { useLazyApiData, useStores } from '../../data/store'
import { UploadEntityFile } from './UploadEntityFile'

const EntityConfigurations = () => {
  const { getAllEntities, downloadEntityConfiguration, updateEntityConfiguration, getCodeNames } = useStores(
    (store) => ({
      getAllEntities: store.entityMaster.getAllEntities,
      downloadEntityConfiguration: store.approvals.downloadEntityConfiguration,
      updateEntityConfiguration: store.approvals.updateEntityConfiguration,
      getCodeNames: store.user.fetchCodeNames,
    }),
  )

  const [lazyDownloadEntityConfiguration, downloadEntityConfigurationHandler] =
    useLazyApiData(downloadEntityConfiguration)
  const [lazyUpdateEntityConfiguration, updateEntityConfigHandler] = useLazyApiData(updateEntityConfiguration)
  const [getAllEntitiesApi, getAllEntitiesHandler] = useLazyApiData(getAllEntities)
  const [lazyGetCodeNames, lazyGetCodeNamesHandler] = useLazyApiData(getCodeNames)

  const updateEntityFormRef = React.useRef(null)
  const downloadEntityFormRef = React.useRef(null)

  useEffect(() => {
    getAllEntitiesApi({}, { page: 1, size: 10000 })
    lazyGetCodeNames('ENTITY_CONFIG_TYPE')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onActionButtonPress = useCallback(
    (props: ActionButtonProps) => {
      console.log('props?.title?.toLowerCase()', props?.title)
      props.values.processingEntityId = props.values.processingEntityId.split('-')[0]
      if (props?.title?.toLowerCase() === 'download') {
        lazyDownloadEntityConfiguration(props?.values)
      } else {
        lazyUpdateEntityConfiguration(props?.values)
      }
    },
    [lazyDownloadEntityConfiguration, lazyUpdateEntityConfiguration],
  )

  const actionButtons = useCallback(
    (props: ActionButtonProps) => {
      console.log('htag props', props)
      return (
        <Box alignSelf={'center'} marginTop={28}>
          <GradientButton
            title={props?.title}
            disabled={!props?.isValid}
            onPress={() => onActionButtonPress(props)}
            isLoading={
              (props?.title?.toLowerCase() === 'download' && downloadEntityConfigurationHandler?.state === 'pending') ||
              updateEntityConfigHandler?.state === 'pending'
            }
            width={280}
            height={32}
          />
        </Box>
      )
    },
    [downloadEntityConfigurationHandler?.state, onActionButtonPress, updateEntityConfigHandler?.state],
  )
  console.log('updateEntityFormRef', updateEntityFormRef)
  useEffect(() => {
    if (updateEntityConfigHandler?.state === 'fulfilled') {
      updateEntityFormRef?.current?.resetForm?.()
    } else if (downloadEntityConfigurationHandler?.state === 'fulfilled') {
      downloadEntityFormRef?.current?.resetForm?.()
    }
  }, [updateEntityConfigHandler?.state, downloadEntityConfigurationHandler])

  console.log('lazyGetCodeNamesHandler?.data', lazyGetCodeNamesHandler?.data)

  const entityIdList = getAllEntitiesHandler?.data?.content?.map((item) => ({
    ...item,
    value: item?.ID + '-' + item?.name,
  }))

  const entityConfigType = Object.keys(lazyGetCodeNamesHandler?.data ?? {})?.map((key) => ({ value: key }))

  const onRetry = useCallback(() => {
    getAllEntitiesHandler?.state === 'rejected' && getAllEntitiesApi({}, { page: 1, size: 10000 })
    lazyGetCodeNamesHandler?.state === 'rejected' && lazyGetCodeNames('ENTITY_CONFIG_TYPE')
  }, [getAllEntitiesApi, getAllEntitiesHandler?.state, lazyGetCodeNames, lazyGetCodeNamesHandler?.state])

  return (
    <Container
      isLoading={getAllEntitiesHandler.state === 'pending' || lazyGetCodeNamesHandler?.state === 'pending'}
      errorMessage={getAllEntitiesHandler?.data?.message || lazyGetCodeNamesHandler?.data?.message}
      onRetry={onRetry}>
      <EntityConfigContainer title={'Download Processor Configurations'}>
        <Form
          ref={downloadEntityFormRef}
          formData={entityConfigForm('DOWNLOAD_FORM', entityIdList, entityConfigType) as any}
          actionButtons={actionButtons}
          container={FormContainer}
        />
      </EntityConfigContainer>
      <SpacerNew size={40} direction="vertical" />
      <EntityConfigContainer title={'Update Processor Configurations'}>
        <Form
          ref={updateEntityFormRef}
          formData={entityConfigForm('UPDATE_FORM', entityIdList, entityConfigType) as any}
          actionButtons={actionButtons}
          container={FormContainer}
        />
      </EntityConfigContainer>
    </Container>
  )
}

export default EntityConfigurations

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  topContainer: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    backgroundColor: '#f8f9fc' as ColorOptions,
  } as BoxProps,
  title: {
    fontFamily: 'jiotype-bold',
    color: '#214796' as ColorOptions,
    fontSize: 16,
  } as TextProps,
  formContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  } as BoxProps,
  textinputStyle: {
    borderColor: '#D1D3E2' as ColorOptions,
    labelPaddingBottom: 8,
    borderRadius: 4,
    labelFontFamily: 'jiotype-medium',
    labelColor: '#757575' as ColorOptions,
    labelFontSize: 12,
    fontSize: 12,
    fontWeight: '500',
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    color: 'BLACK_21',
    paddingVertical: 6,
    placeholderTextColor: '#757575' as ColorOptions,
    bgColor: 'WHITE',
    type: 'label',
  },
  dropDownStyle: {
    fullWidthContent: true,
    minHeight: 35,
    textPaddingFromLeft: 14,
    labelType: 'label',
  } as any,
}

interface EntityConfigContainerProps {
  title: string
  children?: any
}

export const EntityConfigContainer = ({ title, children }: EntityConfigContainerProps) => {
  return (
    <>
      <Box {...styles.topContainer}>
        <Text {...styles.title} title={title} />
      </Box>
      <Box {...styles.formContainer}>{children}</Box>
    </>
  )
}

const entityConfigForm = (type: 'DOWNLOAD_FORM' | 'UPDATE_FORM', entityIdList = [], entityConfigType = []) => [
  {
    key: 'entityConfigForm',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'processingEntityId',
            ComponentName: DropdownOptimised,
            label: 'Select Processor ID',
            validationSchema: required,
            data: entityIdList,
            showSearch: true,
            maxHeight: 400,
            labelStyle: {
              type: 'label',
              color: '#757575',
              fontFamily: 'jiotype-medium',
            },
            ...styles.dropDownStyle,
          },
          {
            fieldName: 'configType',
            ComponentName: DropdownOptimised,
            label: 'Select ConfigType',
            validationSchema: required,
            data: entityConfigType,
            showSearch: true,
            maxHeight: 400,
            labelStyle: {
              type: 'label',
              color: '#757575',
              fontFamily: 'jiotype-medium',
            },
            ...styles.dropDownStyle,
          },
          ...(type === 'DOWNLOAD_FORM'
            ? []
            : [
                {
                  fieldName: 'entityFileData',
                  ComponentName: UploadEntityFile,
                  label: 'Select ConfigType',
                  title: 'ConfigType',
                  validationSchema: required,
                },
              ]),
        ],
      },
    ],
    horizontalFlex: 1,

    actionTitle: type === 'DOWNLOAD_FORM' ? 'Download' : 'Update',
  },
]

const FormContainer = ({ children }) => (
  <Box height={'100%'} backgroundColor={'WHITE'}>
    {children}
  </Box>
)
